const nebulaTheme = {
    label: 'Nebula',
    background: '#212135',
    title: '#BE3C88',
    typeBoxText: '#19B3B8'

}

const horizonTheme = {
    label: 'Horizon',
    background: '#1C1E26',
    title: '#E4A88A',
    typeBoxText: '#BBBBBB'
}

const superUserTheme = {
    label: 'Super User',
    background: '#262A33',
    title: '#43FFAF',
    typeBoxText: '#526777'
}


const aetherTheme = {
    label: 'Aether',
    background: '#101820',
    title: '#EEDAEA',
    typeBoxText: '#C4436F'
}

const miamiNightsTheme = {
    label: 'Miami-Nights Theme',
    background: '#18181A',
    title: '#FFD3A1',
    typeBoxText: '#3ABAC0'
}

const auroraTheme = {
    label: 'Aurora Theme',
    background: '#011826',
    title: '#B3B3B0',
    typeBoxText: '#005E59'
}

const bouquetTheme = {
    label: 'Bouquet Theme',
    background: '#173F35',
    title: '#C8E0D2',
    typeBoxText: '#CE948E'
}

const bushidoTheme = {
    label: 'Bushido Theme',
    background: '#242933',
    title: '#F6F0E9',
    typeBoxText: '#C7464F'
}

const  darkMagicGirlTheme= {
    label: 'DarkMagicGirl Theme',
    background: '#091F2C',
    title: '#A288D9',
    typeBoxText: '#93E8C8'
}

const  fireTheme= {
    label: 'Fire Theme',
    background: '#942017',
    title: '#FFFD55',
    typeBoxText: '#000854'
}

export const themeOptions = [
    {value: nebulaTheme, label: 'Nebula Theme'},
    {value: horizonTheme, label: 'Horizon Theme'},
    {value: superUserTheme, label: 'Super User'},
    {value: aetherTheme, label: 'Aether Theme'},
    {value: miamiNightsTheme, label: 'Miami-Nights Theme'},
    {value: auroraTheme, label: 'Aurora Theme'},
    {value: bouquetTheme, label: 'Bouquet Theme'},
    {value:bushidoTheme , label: 'Bushido Theme'},
    {value: darkMagicGirlTheme, label: 'DarkMagicGirl Theme'},
    {value:fireTheme , label: 'Fire Theme'}

];